var map = {
	"./1.jpg": 4090,
	"./10.JPG": 5641,
	"./11.JPG": 9010,
	"./12.JPG": 4800,
	"./13.JPG": 5055,
	"./14.PNG": 3877,
	"./15.JPG": 3901,
	"./16.png": 5241,
	"./2.JPG": 9845,
	"./3.PNG": 1830,
	"./4.JPG": 587,
	"./5.PNG": 2652,
	"./6.JPG": 6098,
	"./7.JPG": 8219,
	"./8.JPG": 5416,
	"./86.JPG": 8486,
	"./9.JPG": 9847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9283;